const DEVELOPMENT = 'development';
const PRODUCTION = 'production';
const LOCAL = 'local';

export { PRODUCTION, DEVELOPMENT, LOCAL };
